import { GROUP_BADGE, type PublicEvent, publicPerformersList } from "../types/public";

export type HomeQuickFilter =
  | { kind: "person"; label: string; terms: string[] }
  | { kind: "group"; label: string; groupCode: string; terms: string[] };

/** 表サイト：出演者ですぐ探す（個人） */
export const HOME_QUICK_PERSON_LABELS = [
  "宮本佳林",
  "譜久村聖",
  "竹内朱莉",
  "石田亜佑美",
  "佐藤優樹",
  "宮崎由加",
  "植村あかり",
  "佐々木莉佳子",
  "稲場愛香",
  "森戸知沙希",
  "小関舞",
  "浅倉樹々",
] as const;

/** 表サイト：グループですぐ探す（group_code と文言の両方） */
export const HOME_QUICK_GROUP_FILTERS: { label: string; groupCode: string; terms: string[] }[] = [
  { label: GROUP_BADGE.mm.label, groupCode: "mm", terms: ["モーニング娘", "モーニング娘。", "モーニング 娘"] },
  { label: GROUP_BADGE.angerme.label, groupCode: "angerme", terms: ["アンジュルム"] },
  { label: GROUP_BADGE.juice.label, groupCode: "juice", terms: ["Juice=Juice", "Juice = Juice", "ジュース"] },
  { label: GROUP_BADGE.tsuki.label, groupCode: "tsuki", terms: ["つばきファクトリー", "つばき"] },
  { label: GROUP_BADGE.beyooooonds.label, groupCode: "beyooooonds", terms: ["BEYOOOOONDS", "BEYOO", "ビヨンド"] },
  { label: GROUP_BADGE.ocha.label, groupCode: "ocha", terms: ["OCHA NORMA", "オチャノーマ", "OCHA　NORMA"] },
  { label: GROUP_BADGE.rosy.label, groupCode: "rosy", terms: ["ロージークロニクル", "ロージー"] },
];

const HOME_QUICK_FILTERS: HomeQuickFilter[] = [
  ...HOME_QUICK_PERSON_LABELS.map((label) => ({ kind: "person" as const, label, terms: [label] })),
  ...HOME_QUICK_GROUP_FILTERS.map((g) => ({
    kind: "group" as const,
    label: g.label,
    groupCode: g.groupCode,
    terms: g.terms,
  })),
];

const FILTER_BY_LABEL = new Map(HOME_QUICK_FILTERS.map((f) => [f.label, f]));

/** 検索・クイック絞り込み用の全文（出演者・グループ名・イベント名など） */
export function eventSearchHaystack(e: PublicEvent): string {
  const groupLabel = e.group_code && GROUP_BADGE[e.group_code] ? GROUP_BADGE[e.group_code].label : "";
  return [
    e.event_name,
    e.venue,
    e.prefecture,
    e.event_date,
    e.time_start,
    e.time_end,
    e.performance_text,
    e.description,
    e.memo,
    groupLabel,
    e.group_code,
    publicPerformersList(e).join(" "),
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
}

function haystackIncludesTerm(hay: string, term: string): boolean {
  const t = term.trim().toLowerCase();
  if (!t) return false;
  return hay.includes(t);
}

function matchesQuickFilterSpec(hay: string, spec: HomeQuickFilter, groupCode?: string | null): boolean {
  if (spec.kind === "group") {
    if (groupCode && groupCode === spec.groupCode) return true;
    return spec.terms.some((term) => haystackIncludesTerm(hay, term));
  }
  return spec.terms.some((term) => haystackIncludesTerm(hay, term));
}

/** 検索欄・クイックチップ用（表サイト・管理画面共通） */
export function matchesSearchQuery(hay: string, q: string, groupCode?: string | null): boolean {
  const raw = q.trim();
  if (!raw) return true;
  const spec = FILTER_BY_LABEL.get(raw);
  if (spec) return matchesQuickFilterSpec(hay, spec, groupCode);
  return haystackIncludesTerm(hay, raw);
}

/** 検索欄の文字列、またはクイックチップのラベルで予定にマッチするか */
export function matchesHomeSearch(e: PublicEvent, q: string): boolean {
  return matchesSearchQuery(eventSearchHaystack(e), q, e.group_code);
}

export function isHomeQuickFilterLabel(q: string): boolean {
  return FILTER_BY_LABEL.has(q.trim());
}
